var stylists = {

	triggerEl: $('.stylist-trigger'),
	targetEl: $('.stylist-target'),

	nav: function() {
		stylists.triggerEl.click(function(){
			var _this = $(this);

			if (_this.hasClass('current')) {
				return;
			} else {
				var stylist = _this.attr('data-stylist-trigger');

				stylists.triggerEl.removeClass('current');
				stylists.targetEl.removeClass('current');

				_this.addClass('current');
				var targets = $('[data-stylist-target="' + stylist + '"]');
				targets.addClass('current');

				setTimeout(function() {
					targets.find('.widget-carousel-news-feed').flickity('resize');

					var ellipsisEl = targets.find('.ellipsis-new');
					if (ellipsisEl.length) {
						ellipsisEl.each(function(){
							var _this = $(this);
							_this.trigger('destroy').removeAttr('style');
							setTimeout(function() {
								ellipsisNew.applyEllipsis(_this);
							},50);
						});
					}
				},50);
			}
		});
	},

	init: function() {
		if (stylists.triggerEl.length) {
			stylists.nav();
		}
	}
};